CalendarDayView = require 'views/calendar/calendar-day-view'

module.exports = class CalendarMonthDayView extends CalendarDayView
  tagName: 'td'
  className: 'day-cell'

  initialize: ({ @scrollIntoView }) ->
    super

  render: ->
    super(monthView: true)

  expand: ->
    super
    $day = @$('.calendar-day')
    @scrollIntoView(top: @$el.prop('offsetTop'), height: $day.outerHeight())



// WEBPACK FOOTER //
// ./app/scripts/views/calendar/calendar-month-day-view.coffee